import React, { useRef } from 'react';
import fileSaver from 'file-saver';
import PropTypes from 'prop-types';
import Button from '../buttons/Button';
import Dialog from '../dialogs/Dialog';
import './ManualPDF.scss';
import { useDidMount } from '../utils/hooks';

/**
 * ManualPDF Component
 * @module
 * @param {func} getManual - Function to get manual
 * @param {func} getListManual - Function to get manual list
 * @param {manualProps} manualProps - Props for manual
 * @param {bool} isOpenManualDialogPDF - Is manual dialog PDF open?
 * @param {string} manualTitle - Manual title
 * @param {string} titlePDF - PDF title
 * @param {func} handleClosePDF - Close PDF
 */

let _createdUrl = null;

const ManualPDF = (props) => {
  const iframePdfRef = useRef(null);

  useDidMount(() => {
    if (!props.extraDialog) {
      props.getManual();
    }
  });

  // const handleConfirm = () => {
  //   handleStatementPrint();
  // };

  const handleStatementPrint = () => {
    if (iframePdfRef.current !== undefined) {
      const iframePdfContent = iframePdfRef.current.contentWindow;
      if (iframePdfContent) {
        try {
          iframePdfContent.focus();
          iframePdfContent.print();
        } catch (e) {
          const win = window.open(_createdUrl, '_blank');
          win.focus();
        }
      }
    }
  };

  const handleDownload = () => {
    if (props.manualProps.manualBlob) {
      fileSaver.saveAs(props.manualProps.manualBlob, props.manualProps.manualFileName);
    }
  };

  const handleClose = () => {
    props.handleClosePDF();
  };

  const { manualProps } = props;
  _createdUrl = null;
  if (manualProps.manualBlob) {
    _createdUrl = URL.createObjectURL(manualProps.manualBlob, manualProps.manualFileName);
  }

  return props.extraDialog ? (
    <Dialog
      isOpen={props.isOpenManualDialogPDF}
      onClose={handleClose}
      onConfirm={handleClose}
      fullscreen={true}
      title={props.titlePDF}
    >
      <div className='manual-pdf'>
        <div className="report-buttons">
          <Button
            label="Tlačiť"
            primary={true}
            icon="print"
            onClick={handleStatementPrint}
          />
          <Button
            label="Stiahnúť dokument"
            primary={true}
            icon="download"
            onClick={handleDownload}
          />
        </div>
        <iframe
          src={_createdUrl + '#toolbar=1&navpanes=1'}
          title={props.manualTitle}
          ref={iframePdfRef}
        >
        </iframe>
      </div>
    </Dialog >
  ) :
    (_createdUrl &&
      <div className='manual-pdf'>
        <div className="report-buttons">
          <Button
            label="Tlačiť"
            primary={true}
            icon="print"
            onClick={handleStatementPrint}
          />
          <Button
            label="Stiahnúť dokument"
            primary={true}
            icon="download"
            onClick={handleDownload}
          />
        </div>
        <iframe
          src={_createdUrl + '#toolbar=1&navpanes=1'}
          title={props.manualTitle}
          ref={iframePdfRef}
        >
        </iframe>
      </div>
    )
}

ManualPDF.propTypes = {
  manualProps: PropTypes.shape({
    hasList: PropTypes.bool.isRequired,
    hasCustom: PropTypes.bool,
    manualCustom: PropTypes.arrayOf(PropTypes.object),
    listManual: PropTypes.object,
    user: PropTypes.object,
    manualBlob: PropTypes.object,
    manualFileName: PropTypes.string,
    manualTitle: PropTypes.string,
    manualList: PropTypes.arrayOf(PropTypes.object),
    manualListData: PropTypes.array,
    manualListDataMap: PropTypes.object
  }).isRequired,
  isOpenManualDialogPDF: PropTypes.bool,
  getManual: PropTypes.func,
  manualTitle: PropTypes.string,
  titlePDF: PropTypes.string,
  handleClosePDF: PropTypes.func,
}

export default ManualPDF;